import { NoChange } from "./ContentBase";
import { ComponentWrapper } from "./ContentComponent";

class compMemo {
  deps:any[];
  render2:()=>any;
  #lastDeps:any[];
  render() {
    if(this.#lastDeps && this.#lastDeps.length===this.deps.length) {
      let same=true;
      for(let i=0;i<this.#lastDeps.length;i++) {
        if(this.#lastDeps[i]!==this.deps[i]) {same=false;break;}
      }
      if(same) {
        this.deps=undefined;
        return new NoChange();
      }
    }
    this.#lastDeps=Object.assign({},this.deps);
    this.deps=undefined;
    return this.render2();
  }
}

export function memo(deps:any[],render:()=>any):ComponentWrapper {
  if(!deps || !Array.isArray(deps)) throw new Error("Katla: memo deps argument must be array");
  if(!render || typeof render!=="function") throw new Error("Katla: memo render argument must be function");
  return [compMemo,{deps,render2:render}];
}
